import { useDispatch } from 'react-redux'
import { Icon } from '../../../../../common/html/icon'
import { removeTrendConfig } from '../../store/slice'

export const ActionDelete = ({ rowId }) => {
  const dispatch = useDispatch()

  const removeAction = () => {
    dispatch(removeTrendConfig({ rowId }))
  }

  return (
    <div className="dFlex alignItems justifyContentCenter">
      <Icon
        className="icon-delete-circle-fill"
        style={{ fontSize: 13, color: '#9C9C9C' }}
        onClick={removeAction}
      />
    </div>
  )
}
